import { render, staticRenderFns } from "./Sharer.vue?vue&type=template&id=16165d96&scoped=true"
import script from "./Sharer.vue?vue&type=script&lang=js"
export * from "./Sharer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16165d96",
  null
  
)

export default component.exports